import { useEffect, useState } from "react";

const coarsePointerQuery = "(pointer: coarse)";

const getMediaQueryList = (): MediaQueryList | null =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(coarsePointerQuery)
        : null;

export const useIsTouchPrimary = (): boolean => {
    const [mq] = useState(getMediaQueryList);
    const [isTouchPrimary, setIsTouchPrimary] = useState(mq ? mq.matches : true);

    useEffect(() => {
        if (!mq) {
            return undefined;
        }
        const handleChange = (event: MediaQueryListEvent) => {
            setIsTouchPrimary(event.matches);
        };
        mq.addEventListener("change", handleChange);
        return () => mq.removeEventListener("change", handleChange);
    }, [mq]);

    return isTouchPrimary;
};
